var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from "react";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { Hr } from "@irati/ui/src/Layout";
import padding from "@irati/ui/src/global/padding";
import { FormattedMessage, FormattedCurrency } from "@irati/utils/lang";
import { Body } from "@irati/ui/src/Typography";
var RowPadding = styled(function (_a) {
    var padSubtotal = _a.padSubtotal, rest = __rest(_a, ["padSubtotal"]);
    return React.createElement(Row, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var padSubtotal = _a.padSubtotal;
    return (padSubtotal ? "padding-bottom: " + padding.tiny + ";" : null);
});
export var ZipDetail = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 5px;\n"], ["\n  margin-left: 5px;\n"])));
var Subtotal = /** @class */ (function (_super) {
    __extends(Subtotal, _super);
    function Subtotal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Subtotal.prototype.render = function () {
        var _a = this.props, subtotal = _a.subtotal, discount = _a.discount, padSubtotal = _a.padSubtotal, walletBalanceToUse = _a.walletBalanceToUse, currency = _a.currency;
        return (React.createElement("div", { className: "orderSummarySubtotal" },
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12 },
                    React.createElement(RowPadding, { padSubtotal: padSubtotal && discount > 0 },
                        React.createElement(Col, { xs: 10 },
                            React.createElement(Body, { small: true },
                                React.createElement(FormattedMessage, { id: "perks.components.orderSummary.subtotal.subtotal" }))),
                        React.createElement(Col, { xs: 2 },
                            React.createElement("div", { className: "pull-right" },
                                React.createElement(Body, { small: true },
                                    React.createElement(FormattedCurrency, { currency: currency, value: subtotal }))))),
                    discount > 0 && (React.createElement(Row, null,
                        React.createElement(Col, { xs: 7 },
                            React.createElement(Body, { small: true },
                                React.createElement(FormattedMessage, { id: "perks.components.orderSummary.subtotal.discount" }))),
                        React.createElement(Col, { xs: 5 },
                            React.createElement("div", { className: "pull-right" },
                                React.createElement(Body, { small: true },
                                    "- ",
                                    React.createElement(FormattedCurrency, { currency: currency, value: discount })))))),
                    walletBalanceToUse > 0 && (React.createElement(Row, null,
                        React.createElement(Col, { xs: 8 },
                            React.createElement(FormattedMessage, { id: "perks.components.orderSummary.subtotal.perkboxWallet" })),
                        React.createElement(Col, { xs: 4 },
                            React.createElement("div", { className: "pull-right" },
                                React.createElement(Body, null,
                                    "- ",
                                    React.createElement(FormattedCurrency, { currency: currency, value: walletBalanceToUse })))))),
                    React.createElement(Hr, null)))));
    };
    Subtotal.defaultProps = {
        padSubtotal: false,
        walletBalanceToUse: 0,
        isZipTicked: false
    };
    return Subtotal;
}(PureComponent));
export default Subtotal;
var templateObject_1, templateObject_2;
